module.exports = __webpack_public_path__ + "static/media/Ceal.43ed077c.jpg";